import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { AddUser } from './components';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  content: {
    marginTop: theme.spacing(2)
  }
}));

const Users = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <AddUser />
    </div>
  );
};

export default Users;
